/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui'

import WithDefaultLayout from '/components/hocs/DefaultLayout'
import MobileWallpapersPage from '/components/Korea/MobileWallpapersPage'
import logger from '/infra/logger'
import { getEntry } from '/lib/contentful'

const MobileWallpapers = (props) => {
  return <MobileWallpapersPage {...props} isMobile={props.isMobile} />
}

export default WithDefaultLayout(MobileWallpapers, true)

export const getServerSideProps = async (ctx) => {
  const { query } = ctx
  const locale = 'kr'
  const isLayoutFullWidth = false

  try {
    const [meta, sideMenu, languageSwitch, digitalpage, footer] =
      await Promise.all([
        getEntry('meta', locale),
        getEntry('sidemenu_layout', locale),
        getEntry('language_switch', locale),
        getEntry('digital_layout', locale),
        getEntry('my_page_footer', locale),
      ])

    return {
      props: {
        locale,
        meta: meta || {},
        sideMenu: sideMenu || null,
        languageSwitch: languageSwitch || null,
        layout: digitalpage || null,
        footer: footer || null,
        query,
        isLayoutFullWidth,
      },
    }
  } catch (error) {
    logger.error(JSON.stringify(error || {}))
    return { props: {} }
  }
}
